export default __webpack_public_path__ + "static/media/Powered_By_Vision_Fitness.653b2e27.png";